var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPromo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 18,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 24 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1F2124",
  fillRule: "evenodd",
  d: "M1.5 0H6v1.5H1.5v3.825a3.751 3.751 0 0 1 0 7.35V16.5H6V18H1.5A1.5 1.5 0 0 1 0 16.5V12a.75.75 0 0 1 .75-.75 2.25 2.25 0 0 0 0-4.5A.75.75 0 0 1 0 6V1.5A1.5 1.5 0 0 1 1.5 0m6 0v1.5h15v15h-15V18h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 22.5 0zm6 7.5c-1.24 0-2.25-1.01-2.25-2.25S12.26 3 13.5 3s2.25 1.01 2.25 2.25S14.74 7.5 13.5 7.5m0-3a.751.751 0 0 0 0 1.5.751.751 0 0 0 0-1.5M18 15c-1.24 0-2.25-1.01-2.25-2.25S16.76 10.5 18 10.5s2.25 1.01 2.25 2.25S19.24 15 18 15m0-3a.75.75 0 0 0-.75.75c0 .412.337.75.75.75s.75-.338.75-.75A.75.75 0 0 0 18 12m2.78-6.97a.75.75 0 0 0-1.06-1.06l-9 9a.75.75 0 0 0 1.06 1.06zM7.5 3.75H6v1.5h1.5zm0 3H6v1.5h1.5zm-1.5 3h1.5v1.5H6zm1.5 3H6v1.5h1.5z",
  clipRule: "evenodd"
})));
export default SvgPromo;